/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AtoNType
 */
export interface AtoNType {
    /**
     * The id of the AtoN type
     * @type {number}
     * @memberof AtoNType
     */
    id?: number;
    /**
     * The name of the AtoN type
     * @type {string}
     * @memberof AtoNType
     */
    name?: string;
}

/**
 * Check if a given object implements the AtoNType interface.
 */
export function instanceOfAtoNType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AtoNTypeFromJSON(json: any): AtoNType {
    return AtoNTypeFromJSONTyped(json, false);
}

export function AtoNTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtoNType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function AtoNTypeToJSON(value?: AtoNType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

